import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { apiBase } from '../../lib/api';

const API_BASE = apiBase();

// Hands the token to the worker, which sets the operator cookie
// (Domain=.dreamlink.global) and 302s to /operator.
export function OperatorVerify() {
  const [params] = useSearchParams();
  useEffect(() => {
    const token = params.get('token');
    if (!token) return;
    window.location.href = `${API_BASE}/auth/operator/magic-link/verify?token=${encodeURIComponent(token)}`;
  }, [params]);
  return (
    <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', fontFamily: "'Archivo', 'DM Sans', sans-serif", fontWeight: 600, fontSize: 20, letterSpacing: '-0.01em', color: '#590b11', background: '#F5F2EE' }}>
      Signing you in.
    </main>
  );
}
